module.exports = __webpack_public_path__ + "static/media/bulle_discovery_EN_2.ee9bb542.png";